import Products from '@views/products/ProductsVendor.vue';

export default [
  {
    name: 'Lista prodotti',
    path: '/prodotti',
    component: Products,
    meta: { requiresAuth: true }
  }
];
